
export const apiRootUrl = import.meta.env.VITE_ADMINAPI_ROOT;
export const photoRootUrl = import.meta.env.VITE_PHOTO_ROOT;
export const videoRootUrl = "https://videos.mypapik.com";

const routes = (apiRootPath: string) => ({
    data: `${apiRootPath}`,
    auth: `${apiRootPath}/auth`,
    dashboard: {
        totals: `${apiRootPath}/dashboard/totals`,
        newByDate: `${apiRootPath}/dashboard/new-by-date`,
        newByDate2: `${apiRootPath}/dashboard/new-by-date-2`,
        newByGenderClid: `${apiRootPath}/dashboard/new-by-gender-clid`,
        newByGenderClid2: `${apiRootPath}/dashboard/new-by-gender-clid-2`,
        activeByDate: `${apiRootPath}/dashboard/active-day-by-day`,
        activeByDate2: `${apiRootPath}/dashboard/active-day-by-day-2`,
        usersByCity: `${apiRootPath}/dashboard/users-by-city`,
        depositsByDay: `${apiRootPath}/dashboard/deposits-by/day`,
        depositsByDay2: `${apiRootPath}/dashboard/deposits-by-2/day`,
        depositsByMonth: `${apiRootPath}/dashboard/deposits-by/month`,
        depositsByMonth2: `${apiRootPath}/dashboard/deposits-by-2/month`,
        retentionByClaims: `${apiRootPath}/dashboard/retention-by-claims`,

    },
    uploadAsset: `${apiRootPath}/uploadAsset`,
    sendEmail: `${apiRootPath}/sendEmail`,
    sendEvent: `${apiRootPath}/sendEvent`,
    batchEmails: `${apiRootPath}/batchEmails`,
    blackList: `${apiRootPath}/blackList`,
    myTenants: `${apiRootPath}/my-tenants`,
})

export const apiRoutes = routes(apiRootUrl);


